import { instance, next } from "./base";

export const signUp = async (values) => {
  const { data } = await instance()
    .post("/api/v1/auth/signup", values)
    .catch((e) => next(e));
  return data?.data;
};

export const verifyAccount = async (values) => {
  const { data } = await instance()
    .post("/api/v1/auth/verify/phone-number", values)
    .catch((e) => next(e));
  return data?.data;
};

export const getProfile = async () => {
  const { data } = await instance()
    .get("/api/v1/user/profile")
    .catch((e) => next(e));
  return data?.data;
};

export const updateDeliveryAddress = async (values) => {
  const { data } = await instance()
    .patch("/api/v1/user/delivery-address", values)
    .catch((e) => next(e));
  return data?.data;
};

export const getPin = async () => {
  const { data } = await instance()
    .get("/api/v1/auth/has-pin")
    .catch((e) => next(e));
  return data?.data;
};

export const forgetPassword = async (values) => {
  const { data } = await instance()
    .post("/api/v1/auth/send/reset/password/otp", values)
    .catch((e) => next(e));
  return data?.data;
};

export const setPassword = async (values) => {
  const { data } = await instance()
    .patch("/api/v1/auth/reset/password", values)
    .catch((e) => next(e));
  return data?.data;
};

export const verifyOTP = async (values) => {
  const { data } = await instance()
    .post("/api/v1/auth/verify/otp", values)
    .catch((e) => next(e));
  return data?.data;
};

export const searchUser = async (values) => {
  const { data } = await instance()
    .get("/api/v1/user/search", { params: { query: values.query } })
    .catch((e) => next(e));
  return data?.data;
};

export const createPin = async (values) => {
  const { data } = await instance()
    .patch("/api/v1/auth/pin/create", values)
    .catch((e) => next(e));
  return data?.data;
};

export const resetPin = async (values) => {
  const { data } = await instance()
    .patch("/api/v1/auth/reset-pin", values)
    .catch((e) => next(e));
  return data?.data;
};

export const notificationSettings = async (values) => {
  const { data } = await instance()
    .patch("/api/v1/user/notification", values)
    .catch((e) => next(e));
  return data?.data;
};

export const verifyBVN = async (values) => {
  const { data } = await instance("wallet")
    .post("/api/v1/wallet/verify-bvn", values)
    .catch((e) => next(e));
  return data?.data;
};

export const requestDeleteProfile = async (values) => {
  const { data } = await instance()
    .post("/api/v1/user/request-delete", values)
    .catch((e) => next(e));
  return data?.data;
};

export const deleteProfile = async (values) => {
  const { data } = await instance()
    .post("/api/v1/user/delete-profile", values)
    .catch((e) => next(e));
  return data?.data;
};
